import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useConfigurationStore from './store/configurationStore';
import Wizard from './components/Wizard';
import LanguageSwitcher from './components/LanguageSwitcher';

function App() {
    const { t } = useTranslation();
    const { loading, loadData } = useConfigurationStore();

    useEffect(() => {
        loadData();
    }, []);

    if (loading) {
        return (
            <div className="ast-app">
                <header className="ast-header">
                    <h1 className="ast-header__title">{t('app.title')}</h1>
                    <LanguageSwitcher />
                </header>
                <div className="ast-loading">
                    <div className="ast-loading__spinner"></div>
                    <p>{t('app.loading')}</p>
                </div>
            </div>
        );
    }

    return (
        <div className="ast-app">
            <header className="ast-header">
                <h1 className="ast-header__title">{t('app.title')}</h1>
                <LanguageSwitcher />
            </header>
            <Wizard />
        </div>
    );
}

export default App;
